import React, { useEffect, useState } from 'react';

import LogoLoader from 'components/Loader/LogoLoader';
import AddClockInTime from 'containers/EmployeeTimeClock/AddClockInTime';
import ClockedInDetail from 'containers/EmployeeTimeClock/ClockedInDetail';
import { useCheckClockIn } from 'hooks/timeClock/useCheckClockIn';
import { useTimeClockStore } from 'store/useTimeClockStore';

const EmployeeTimeClockLanding: React.FC<unknown> = () => {
  const [clockIn, setClockIn] = useState<boolean>(false);

  const timeClockDetails: any = useTimeClockStore(state => state.timeClock);

  const { status: checkClockInStatus, isFetching } = useCheckClockIn();

  useEffect(() => {
    if (timeClockDetails) {
      setClockIn(true);
    }
    if (!timeClockDetails) {
      setClockIn(false);
    }
  }, [timeClockDetails, checkClockInStatus]);

  if (checkClockInStatus === 'loading' || isFetching) return <LogoLoader />;

  return (
    <>
      <div>
        {!clockIn && <AddClockInTime />}
        {clockIn && <ClockedInDetail />}
      </div>
    </>
  );
};
export default EmployeeTimeClockLanding;
